import { http } from "./Config";
import settings from "@/settings";
export default {
  
  list: () => {
    return http.get(
        settings.usuarioAutenticado.GET_PRODUTO +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE
    );
  },

};
